import { NgStyleKeyValue } from "@angular/flex-layout/extended/typings/style/style-transforms";
import { NumberValueAccessor } from "@angular/forms";
import { Dto, DtoWithId } from "@mango/core";
import { Regelstatus } from "../enums/regelstatus";
import { Instrument } from "./instrument";
import { Personeel } from "./personeel";
import { Project } from "./project";
import { Relatie } from "./relatie";
import { Taal } from "./taal";
import { Tekst } from "./tekst";
import { TypeCalculatie } from "./type-calculatie";
import { Volgblad } from "./volgblad";
import { Voorblad } from "./voorblad";


@Dto({fullName: "CIJBorculo.Logic.Projectregel"})
export class Projectregel extends DtoWithId {
	oldID: number;
	project: Project;
	instrument: Instrument;
	werkstandaard1: Instrument;
	werkstandaard2: Instrument;
	werkstandaard3: Instrument;
	werkstandaard4: Instrument;
	werkstandaard5: Instrument;
	werkstandaard6: Instrument;
	voorblad: Voorblad;
	volgblad: Volgblad;
	medewerker: Personeel;
	typeCalculatie: TypeCalculatie;
	datumStart: Date;
	datumAanmaak: Date;
	datumPlanning: Date;
	datumGereed: Date;
	datumPublicatie: Date;
	status: Regelstatus;
	opmerking: string;
	fileVoorblad: string;
	fileVolgblad: string;
	fileVolgbladJus: string;
	gereed: boolean;
	goed: boolean;
	geen: boolean;
	afkeur: boolean;
	justering: boolean;
	reparatie: boolean;
	uitbesteed:boolean;
	gefactureerd:number;
	afkeurTotaal: boolean;
	pdf: boolean;
	conclusie: string;
	prijsKalibratie: number;
	prijsKorting: number;
	prijsTotaal: number;
	prijsMateriaal: number;
	uitbesteed1: string;
	uitbesteed2: string;
	uitbesteed3: string;
	uitbesteed1Mail: string;
	uitbesteed2Mail: string;
	uitbesteed3Mail: string;
	uitbesteed1Datum: Date;
	uitbesteed2Datum: Date;
	uitbesteed3Datum: Date;
	uitbesteedTekst1: Tekst;
	uitbesteedTekst2: Tekst;
	uitbesteedTekst3: Tekst;
	uitbesteedFactuur: string;
	uitbesteedAan: Relatie;
	prijsBlock: boolean;
	periode: number;
	wacht: boolean;	
	taal: Taal;
	certificaat: string;
	certificaatId: number;
	revisie: number;
	kalibratiePrijs: number;
	korting: number;
	uitbesteedOpdracht: string;
	qrCode: string;
	qrCodeImage: string;
	hasPakbon: number;
	isHistorie: boolean;
	factuurDatum: Date;
	pakbonDatum: Date;
	factuurBedrag: number;
	factuurregelBedrag: number;
	factuurNummer: string;
	prijsArtikelen: number;
	lokatieNaam: string;
	lokatieAdres: string;
	lokatiePostcode: string;
	lokatiePlaats: string;
	lokatieTelefoon: string;
	lokatieEmail: string;
	postType: string;
	jaarAanmaak: number;
	weeknummerAanmaak: string;
	rvaValidatieDatum: Date;
	rvaValidatieDoor: string;
	centixId: number;
	lastExportCentix: Date;
	lastExportCentixDoor: string;
	reasonNotExported: string;
	instrumentBinnenSpecs: boolean;
  buitenSpecsAfkeuren: boolean;
}
